define((require) => {
    "use strict";

    const _              = require("underscore");
    const AnimationModel = require("shared/ui/experience/widgets/animations/AnimationModel");

    /**
     * The model for a zoom out animation.
     *
     * @class ZoomOutAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "zoomOut"
        }, AnimationModel.prototype.defaults)
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/zoomOut/ZoomOutAnimationModel.js